import { createSlice } from '@reduxjs/toolkit';
import defaultPages from '../utils/defaultPages';
import { findCompByIdRecursively } from '../utils/functions';

export const pagesSlice = createSlice({
	name: 'pages',
	initialState: {
		value: defaultPages(1),
		//  [
		// {
		//     pageName: "Home",
		//     pageType: "home",
		//     pageId: "default-1",
		//     pageData: [],
		// },
		// {
		//     pageName: "Header",
		//     pageType: "header",
		//     pageId: "header",
		//     pageData: [],
		// },
		// {
		//     pageName: "StoreMenu",
		//     pageType: "store-menu",
		//     pageId: "menu-1",
		//     pageData: []
		// },
		// {
		//     pageName: "Footer",
		//     pageType: "footer",
		//     pageId: "footer",
		//     pageData: []
		// },
		// {
		//     pageName: "Página de Produtos",
		//     pageType: "product",
		//     pageId: "product-1",
		//     pageData: []
		// },
		// {
		//     pageName: "Busca/Dep/Cat",
		//     pageType: "search",
		//     pageId: "search-1",
		//     pageData: [],
		// },
		// {
		//     pageName: "Vitrine",
		//     pageType: "shelf",
		//     pageId: "shelf-1",
		//     pageData: [],
		// },
		// {
		//     pageName: "Minicart",
		//     pageType: "minicart",
		//     pageId: "minicart-1",
		//     pageData: []
		// },
		// {
		//     pageName: "Modal Newsletter",
		//     pageType: "modal-newsletter",
		//     pageId: "modal-1",
		//     pageData: []
		// },
		//  {
		//     pageName: "Breadcrumb",
		//     pageType: "breadcrumb",
		//     pageId: "breadcrumb-1",
		//     pageData: [],
		// }, {
		//     pageName: "Busca Vazia",
		//     pageType: "search-not-found",
		//     pageId: "search-not-found-1",
		//     pageData: [],
		// },
		// ]
	},
	reducers: {
		updatePages: (state, action) => {
			state.value = action.payload;
		},
		addComponent: (state, action) => {
			state = state;
		},
		moveComponent: (state, action) => {
			state = state;
		},
		removeComponent: (state, action) => {
			state = state;
		},
		updateComponent: (state, action) => {
			const pg = state.value.find((page) => page.pageId == action.payload.pageId);
			const result = findCompByIdRecursively(pg.pageData, action.payload.componentId);
			if (result?.comp) {
				Object.assign(result.comp, action.payload.component);
			} else {
				console.error(`Component with ID ${action.payload.componentId} not found`);
			}
		},
		addPage: (state, action) => {
			state.value.push(action.payload);
		},
		removePage: (state, action) => {
			const indexToRemove = state.value.findIndex((page) => page.pageId == action.payload);
			state.value.splice(indexToRemove, 1);
		},
		updatePage: (state, action) => {
			const pg = state.value.find((page) => page.pageId == action.payload.pageId);
			Object.assign(pg, action.payload);
		},
	},
});

// Action creators are generated for each case reducer function
export const {
	addComponent,
	moveComponent,
	removeComponent,
	updateComponent,
	addPage,
	updatePage,
	updatePages,
	removePage,
} = pagesSlice.actions;
export const selectedPageObject = (state) => state.pages.value.find((page) => page.pageId == state.selectPage.value);
export const selectComponentById = (state, pageId, componentId) => {
	const { pageData } = state.pages.value.find((page) => page.pageId == pageId);
	const { comp } = findCompByIdRecursively(pageData, componentId);

	return comp;
};
export const selectPageById = (state, pageId) => {
	return state.pages.value.find((page) => page.pageId == pageId);
};
export const headerPageObject = (state) => state.pages.value.find((page) => page.pageId == 'header');
export const footerPageObject = (state) => state.pages.value.find((page) => page.pageId == 'footer');
export const allPages = (state) => state.pages.value;

export default pagesSlice.reducer;

Array.prototype.swap = function (indexA, indexB) {
	var element = this[indexA];
	this.splice(indexA, 1);
	this.splice(indexB, 0, element);
};
